export enum B2bCartSection {
    Cart,
    Checkout,
    ThankYou,
}

export enum CartPageTypes {
    PROMO = 'promo',
    CATALOG = 'catalog',
    BROCHURE = 'brochure',
    THANKYOU = 'thankyou'
}
